import { App as SrvgApp, TemplateEngine ,TemplateEngineDelegate, InactivityController, VideoSourceController, Server,
         LocalStorageController, StreamingSourceController, ModelUpdateEvent, GuiResizeEvent,
         MaintenanceEvent, DataReceiveEvent } from "@gaming/srvg-classes-core";
import { Timeline } from "./Data/Timeline";
import { TimelineController } from "./Controller/TimelineController";
import { CustomerIntegrationController } from "./Controller/CustomerIntegrationController";
import { PhaseChangeEvent } from "./Event/PhaseChangeEvent";

/**
 * <strong>VF - Virtual Football</strong>
 *
 * This is the application class for VF.
 */
export class App extends SrvgApp implements TemplateEngineDelegate {
    timeline: Timeline;
    timelineController: TimelineController;
    customerIntegrationController: CustomerIntegrationController;
    inactivityController: InactivityController;
    videoSourceController: VideoSourceController;
    maintenanceWorker: Worker;
    server: Server;

    constructor( options ) {
        super( options || {} );
        this.timeline = new Timeline();
        this.timeline.currentChannel = options.currentChannel || 0;
        this.timelineController = new TimelineController( {
            url: srvg.url.timeline,
            matchesUrl: srvg.url.timeline_matches,
            timeline: this.timeline,
            timelineWorkerPath: srvg.url.timeline_worker,
            maintenanceWorkerPath: srvg.url.maintenance_worker
        } );
        this.customerIntegrationController = new CustomerIntegrationController( { wrapper: '#cupView', timeline: this.timeline } );
        srvg.customerIntegration = this.customerIntegrationController;
        this.server = new Server( {} );

        if( options.inactivityController ) {
            this.inactivityController = new InactivityController( { timeout: 2*60*60*1000 } );
        }

        // get settings for betting markets in overlays, from configuration or feature if available
        srvg.overlayBettingMarketsSettings = srvg.featuresInstances.getOverlayBettingMarketsSettings();

        this.templateEngine = new TemplateEngine( {
            url: options.templatesUrl
        } );
        this.templateEngine.setDelegate( this );
        this.templateEngine.initialize();

        // FLOST
        if( srvg.videooptions.flostVideosets ) {
            this.videoSourceController = new LocalStorageController( {} );
        }
        else {
            this.videoSourceController = new StreamingSourceController( {} );
        }


        /******************* connect components ************************/

        this.timeline.chunkRangeModel.addSubscriberForEvent( this.timelineController, ModelUpdateEvent );

        this.addSubscriberForEvent( this.customerIntegrationController, GuiResizeEvent );


        /* Maintenance Handling */
        this.addSubscriberForEvent(srvg.maintenance, MaintenanceEvent);
        var that = this;
        this.maintenanceWorker = new Worker(srvg.url.maintenance_worker);
        this.maintenanceWorker.postMessage({action: 'set_options', options: {
                url: srvg.maintenanceCheck.url,
                frequency: srvg.maintenanceCheck.pollFrequency
            }});
        this.maintenanceWorker.postMessage({action: 'start_polling'});
        this.maintenanceWorker.addEventListener('message', function(e){
            switch( e.data.message ) {
                case 'maintenance':
                    that.triggerEvent(new MaintenanceEvent({maintenance: true}));
                    break;
            }
        });


    }

    handleDataReceiveEvent( event: DataReceiveEvent, provider ) {
    }

    handlePhaseChangeEvent( event: PhaseChangeEvent, provider ) {
        var currentRound = event.chunk.round();
        var currentCycle = event.phase.cycle();

        var setBodyData = {
            'round': currentRound,
            'cycle': currentCycle,
            'chunk': event.chunk.nr,
            'mode': srvg.product.name
        };

        for (var key in setBodyData) {
            $('body').attr('data-' + key, setBodyData[key]);
        }
    }
}
